export enum Route {
  preferenceOld = 'Preference',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  preferenceScreen = 'Preference',
  preferenceNavScreen = 'PreferenceNav',
  logReportsScreen = 'LogReportsScreen',
  reportScreen = 'Report',
  logDetailsScreen = 'LogDetails',
  takeOverSubmitScreen = 'TakeOverSubmit',
  myPost = 'MyPost',
  teamLogs = 'TeamLogs',
  inProgress = 'InProgress',
  takenOver = 'TakenOver',
  takeOverScreen = 'TakeOver',
  myPostScreen = 'MyPostScreen',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  teamLogsScreen = 'TeamLogs',
  testScreen = 'Test',
  createShiftLogScreen = 'CreateShiftLogScreen',
  editShiftLogScreen = 'EditingScreen',
  postComment = 'PostCommentScreen',
  actionListScreen = 'ActionListScreen',
  actionScreen = 'ActionScreen',
  updatePercentage = 'UpdatePercentageScreen',

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  editingScreen = 'EditingScreen',
  editingGroupScreen = 'EditingGroupScreen',
  editingRollupScreen = 'EditingRollupScreen',
  editingRowListScreen = 'EditingRowListScreen',
  editingRowScreen = 'EditingRowScreen',
}
